import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { BrandName } from "../components/BrandName";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BrandsPage() {
  const [brands, setBrands] = useState(null);

  useEffect(() => {
    axios.get(`${API}/brands`).then((r) => setBrands(r.data)).catch(() => setBrands([]));
  }, []);

  return (
    <div className="App grain bg-offwhite min-h-screen" data-testid="brands-page">
      <Navbar />
      <main className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-24">
        <header className="mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-military font-semibold mb-4">Compre por marca</p>
          <h1 className="font-serif text-4xl md:text-6xl text-military-dark tracking-tight">
            Nossas <span className="italic font-light text-military">marcas.</span>
          </h1>
        </header>

        {brands === null ? (
          <p className="text-military-dark/50 text-sm py-20 text-center">Carregando marcas...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="brands-grid">
            {brands.map((b, i) => (
              <motion.div key={b.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}>
                <Link
                  to={`/marca/${b.slug}`}
                  data-testid={`brand-card-${b.slug}`}
                  className="group flex items-center justify-between gap-4 bg-white border border-military/10 rounded-lg p-8 hover:border-military/30 hover:shadow-lg transition-all duration-300"
                >
                  <div>
                    <p className="font-serif text-2xl md:text-3xl text-military-dark group-hover:text-military transition-colors"><BrandName name={b.name} /></p>
                    <p className="text-xs uppercase tracking-[0.2em] text-military-dark/40 mt-2">{b.product_count} produto(s)</p>
                  </div>
                  <span className="w-11 h-11 rounded-full border border-military/20 flex items-center justify-center text-military-dark/50 group-hover:bg-military group-hover:text-offwhite group-hover:border-military transition-all duration-300">
                    <ArrowUpRight size={18} />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
